import { isEmpty } from 'lodash';
import { CrmType, TradeInType } from '@upstart/harmony/lib/constants';
import { Dealer } from '../../types/dealerTypes';
import { CHAIRMAN_ROUTES } from '../../utils/routes';

interface ActionItem {
  name: string;
  isActive: (dealer: Dealer, hasCars?: boolean) => boolean;
  getChairmanUrl?: (dealer: Dealer) => string;
}

export const ACTION_ITEMS: ActionItem[] = [
  {
    name:
      'Inventory provider needs to be set up (Dealer has provided the inventory provider but no feeds are configured)',
    isActive: (dealer) =>
      !!dealer.launchpad?.inventory?.provider && !dealer.Feeds?.length,
    getChairmanUrl: CHAIRMAN_ROUTES.DEALER_EDITOR_INVENTORY,
  },
  {
    name:
      'Feeds are configured, however there are no cars imported yet. An Inventory Import should be needed',
    isActive: (dealer, hasCars) =>
      !!dealer.launchpad?.inventory?.provider &&
      !!dealer.Feeds?.length &&
      !hasCars,
    getChairmanUrl: CHAIRMAN_ROUTES.DEALER_EDITOR_INVENTORY,
  },
  {
    name: 'Send pricing validation email',
    isActive: (dealer, hasCars) =>
      !!hasCars &&
      !!dealer.launchpad?.status?.readyToBeginInventoryConfig &&
      !dealer.launchpad?.status?.implementerVerifiedInventory,
  },
  {
    name:
      'DealerSocket Id & Site number need to be configured (Dealer has selected DealerSocket as their CRM but these fields are not configured)',
    isActive: (dealer) =>
      dealer.crmType === CrmType.DEALERSOCKET &&
      (!dealer.dealersocket?.dealersocketId ||
        !dealer.dealersocket?.dealersocketSiteNumber),
    getChairmanUrl: CHAIRMAN_ROUTES.DEALER_EDITOR_INTEGRATIONS,
  },
  {
    name:
      'Dealer timezone could not be automatically filled in, the address may need to be verified',
    isActive: (dealer) => !!dealer.address && !dealer.timezone,
    getChairmanUrl: CHAIRMAN_ROUTES.DEALER_EDITOR_SPECIFICATIONS,
  },
  {
    name:
      'Dealer taxes could not be automatically filled in and need to be manually set',
    isActive: (dealer) => !!dealer.address && isEmpty(dealer.taxes),
    getChairmanUrl: CHAIRMAN_ROUTES.DEALER_PRICING_EDITOR_TAXES_AND_ADDONS,
  },
  {
    name: 'Shift integration should be enabled for Subaru and Toyota dealers',
    isActive: (dealer) =>
      !!(
        dealer.brand?.includes('Subaru') || dealer.brand?.includes('Toyota')
      ) && !dealer.featureConfig?.shiftDigital?.enabled,
    getChairmanUrl: CHAIRMAN_ROUTES.DEALER_EDITOR_CONFIGURATION,
  },
  {
    name: 'Unite integration should be enabled for Mitsubishi dealers',
    isActive: (dealer) =>
      !!dealer.brand?.includes('Mitsubishi') &&
      !dealer.featureConfig?.unite?.enabled,
    getChairmanUrl: CHAIRMAN_ROUTES.DEALER_EDITOR_CONFIGURATION,
  },
  {
    name: 'FirstLook needs a dealer id and passcode configured',
    isActive: (dealer) =>
      dealer.tradeInManagerType === TradeInType.FIRSTLOOK &&
      (!dealer.firstlook?.dealerId || !dealer.firstlook.passcode),
    getChairmanUrl: CHAIRMAN_ROUTES.DEALER_EDITOR_INTEGRATIONS,
  },
];
